package com.partejar.app.feature.modeloscontrato.data.remote
import kotlinx.serialization.Serializable
@Serializable data class ModeloContratoDto(val modeloContratoId: Long, val nome: String, val ativo: Boolean, val numeroVersao: Int, val conteudoTemplate: String)
@Serializable data class ModeloContratoRequestDto(val nome: String, val conteudoTemplate: String, val ativo: Boolean? = null)
@Serializable data class TemplateVariableDto(val grupo: String, val rotulo: String, val placeholder: String)
